<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX1+yc+7B1LhfgDU+inSCq2k+3jkIZs4v0b0=",
          "cpf": "U2FsdGVkX1928QqCXGCtxD/nbDW3aUcHCW4B56W/qKU="
        }, {
          "num_cand": "U2FsdGVkX1/tDwxiuK8xt+3bFKhMQxJn6Ait74TMdT8=",
          "cpf": "U2FsdGVkX193JpsX+PGiG/oJwcFamg/UnY12j1XvLnU="
        }, {
          "num_cand": "U2FsdGVkX1+YZKZAM1d8hrT8lcCLstILVxxIcwYQxB0=",
          "cpf": "U2FsdGVkX18LgAfUvuvCnHaqLJPdtf9Xr9CHEBwJwKE="
        }, {
          "num_cand": "U2FsdGVkX18ScYJuOKl/Lv8VNXmmCBfUUC9YOaOekG8=",
          "cpf": "U2FsdGVkX188VmDlWNqab8Y6jLt0CaB9gUasuvjsORk="
        }, {
          "num_cand": "U2FsdGVkX18zA2Faz3xrJRjat6fwhHyy3q2+lNcSLzQ=",
          "cpf": "U2FsdGVkX1+mit4ZQSoigliO8YwJdFq5ZMgTIb8bNCU="
        }, {
          "num_cand": "U2FsdGVkX1+zaJHZKiJG66mg2tsa/Qgu3qhcBZ41/U8=",
          "cpf": "U2FsdGVkX1/JsMsaVkyg9GsPvzawxIW4UpnQlpumbaQ="
        }, {
          "num_cand": "U2FsdGVkX1+WQRuhILXPFCgdvddJ9c3aKmcIBjeBc0w=",
          "cpf": "U2FsdGVkX18ldSdq4e/WV5fSn1mWfHkb/E69sv6zmTQ="
        }, {
          "num_cand": "U2FsdGVkX18lwzy8RwqpGyKmLxI8hdM5lhzrD/35jjo=",
          "cpf": "U2FsdGVkX19wAS4vIzrXbet/moxzF6yD20W64mSYpiw="
        }, {
          "num_cand": "U2FsdGVkX1/CazMYMQLynRHQ/DCToXfUKBsycKYIIbE=",
          "cpf": "U2FsdGVkX1/jvgENT8pgRUgjouucB7eCrdpfYtlLDrA="
        }, {
          "num_cand": "U2FsdGVkX1/YqDn5b8NkQUV1sKdxNKPcKRWU1xCognY=",
          "cpf": "U2FsdGVkX18IIZbBPHvQEz13HSOANqrVm/KdWh9jJOQ="
        }, {
          "num_cand": "U2FsdGVkX1/VzfnXvkRv1n96AnsGUWK+ah/UxjA5AWE=",
          "cpf": "U2FsdGVkX18eRMPXFwQfsGzFOEq/ON5Uk9LUExQBuHk="
        }, {
          "num_cand": "U2FsdGVkX1/4LslCdCqxWTYRsvhthk14EknohSSWJ68=",
          "cpf": "U2FsdGVkX18hw7reJSTHxi03FbW31u/PMXd/mXPuQAQ="
        }, {
          "num_cand": "U2FsdGVkX1+gH5aDY9GrHILd1gNXv58R6Tr14ZtHcNQ=",
          "cpf": "U2FsdGVkX1/N6M+AThaeTB5FzqbP33nm3d/nKmEWGZU="
        }, {
          "num_cand": "U2FsdGVkX1+v8W67OOul0FrU7IFsAA9VkUphchL2ZRE=",
          "cpf": "U2FsdGVkX1/bKnpOPG8tT4t4jPBSdKEUn9tIBwgyntc="
        }, {
          "num_cand": "U2FsdGVkX19V3u9JiOwx0n9B3Pe4c+e0pTZbOTWU5PI=",
          "cpf": "U2FsdGVkX18DhDmSUkIi9GgFQZxmy7IIIroT9bEH9uM="
        }, {
          "num_cand": "U2FsdGVkX198VskCUURRWJYEL6RRIwlVG14IZA+tPGs=",
          "cpf": "U2FsdGVkX1/zlptaw5tuCTbwoVSGW7DnzUoH/cVcxEs="
        }, {
          "num_cand": "U2FsdGVkX1/3VgwERhMlv79uq1YdpKdvr/TghbdGJdU=",
          "cpf": "U2FsdGVkX1/njdAgsVcnqeRS/0tV+chv9EEG417kdq8="
        }, {
          "num_cand": "U2FsdGVkX1+s1dOI20K5YQieCjHrZH1qSfuoTz6x9X4=",
          "cpf": "U2FsdGVkX1+Wm0ACfl7Nj+khSHAcE4YayBn6L2hWA3E="
        }, {
          "num_cand": "U2FsdGVkX181b8SD3UdfjAqn8Tx9O7ZEjV7U5yukBew=",
          "cpf": "U2FsdGVkX1+lRL9hEekR4ySoWw9+jAvQVXwzACi2Hoo="
        }, {
          "num_cand": "U2FsdGVkX18/Bvx6PUUmKsGe8/guhLEyeEm0Uziaz74=",
          "cpf": "U2FsdGVkX18rrnVLJJ6IuLxw0a0YT9lF5sNXpKOI73Y="
        }, {
          "num_cand": "U2FsdGVkX1/T3xQNkQ9ROPXo54TlwuVo0k80Th/qSMs=",
          "cpf": "U2FsdGVkX1+wzH0/VGD7QGfjCdUMurR2Ltw2d9L2LWI="
        }, {
          "num_cand": "U2FsdGVkX19jY//1Vaqk+6KsCADyOKZVhzGECtoWUIk=",
          "cpf": "U2FsdGVkX1/Zzj2cFQbjbTqpNhtUMMlDXKZth5lIE8c="
        }, {
          "num_cand": "U2FsdGVkX19eyufomE+EMcKMqJlv7ky9rl0gRWQfN7s=",
          "cpf": "U2FsdGVkX19ujMcSHdBaGcWr+VXJdQUO5NcW+l0jFlE="
        }, {
          "num_cand": "U2FsdGVkX18gQqSlLfkBf7LXDBV6Md2rNkCqCJAoQWw=",
          "cpf": "U2FsdGVkX19eC/KNBpgprTP406QFgVdKBkH6YkAgcxQ="
        }, {
          "num_cand": "U2FsdGVkX18kYVA+0dqaxJPbcB7z9GhBsn9dE79+8xk=",
          "cpf": "U2FsdGVkX19H34HuwQQhLl/0TiHyTZXbBbzxTsPRE+Q="
        }, {
          "num_cand": "U2FsdGVkX18muuvNOUGqfmdGZtgnVsvoIeU/9XIWVK4=",
          "cpf": "U2FsdGVkX1/jiZFbsGVpuCT5QGcsWYBfDKid2pq1Ung="
        }, {
          "num_cand": "U2FsdGVkX1/i4U0zIhsm+G9YsfSocMVFRtOssOUOIBI=",
          "cpf": "U2FsdGVkX1+i0gJXnEdePxCdVJdgNXIdT0L6qKaf6HQ="
        }, {
          "num_cand": "U2FsdGVkX18QzmmJVZia2Tl40une3waTkImZMrj3ygE=",
          "cpf": "U2FsdGVkX19lceUoFsAgRHFJ2tQd7+tHIyn67m0rcWI="
        }, {
          "num_cand": "U2FsdGVkX1/IjBsiZE/OfkIBwQUltI4QCklv0Px5VJw=",
          "cpf": "U2FsdGVkX19wpMHEgyzCv5tzgFZY/w/Dod2Sp5nO1LE="
        }, {
          "num_cand": "U2FsdGVkX19p85aN5BINYM+AlYQHlPos44DOIYLQMSU=",
          "cpf": "U2FsdGVkX18I47MP+zGg3rmvj8nS/ycQaUgG7wZbuO0="
        }, {
          "num_cand": "U2FsdGVkX1/DXxJELVXfSKobc841y+q0H+Nbg+xx7jU=",
          "cpf": "U2FsdGVkX1/ViTr1ZkLx1O4CiuVl9drvpuaOdXDRHiM="
        }, {
          "num_cand": "U2FsdGVkX1+xtiGeo4gQTzQNTEzwfrEdyRJaLRECWk0=",
          "cpf": "U2FsdGVkX1/i3dJ0taen4VDh9XrwjrIuO747RAFWbBY="
        }, {
          "num_cand": "U2FsdGVkX1+mqIWg9hiL8Cs2EXdn96iBcKEpawXKbAI=",
          "cpf": "U2FsdGVkX1+f3qyhU+epFHOUwpvhm7/6EMzxLWHZN3I="
        }, {
          "num_cand": "U2FsdGVkX18fQuKYFJl1hPfY/2Q1zca972hh3tpiTHE=",
          "cpf": "U2FsdGVkX19by196L6yOs3hlcSdO/QlhGq2mBPd81Yk="
        }, {
          "num_cand": "U2FsdGVkX19bVtwIYn5SAK1WDfU6qhvnM5DE6Wu8muU=",
          "cpf": "U2FsdGVkX1/Bvjk2N2rr6wikRfnabQ4gR8iByMaG1kA="
        }, {
          "num_cand": "U2FsdGVkX1+Xeu9co2le8hp2wM8L7jr9kiYjEhM494k=",
          "cpf": "U2FsdGVkX18rRiDP6/qA0d/VfSOfNkVnxGsYK8cIszY="
        }, {
          "num_cand": "U2FsdGVkX188tZ6JuGneAhKb4sMmqVWSwFsNoIpaQe0=",
          "cpf": "U2FsdGVkX1+yHF8ZeUolBbiNOSGVbJdxfbiYy5lDQyU="
        }, {
          "num_cand": "U2FsdGVkX1/Ey+1yx5VyzH4Ymk+i0EipNZwnQdynky4=",
          "cpf": "U2FsdGVkX19iDHS6NOhO5ehOxI01PHRYp1fR25egMVQ="
        }, {
          "num_cand": "U2FsdGVkX199wUlM9I71mdlijLDcDof/j5G2cihcmko=",
          "cpf": "U2FsdGVkX18ZTRD+zpwnZo8uwKnFwRvMH1NMVYwgsdU="
        }, {
          "num_cand": "U2FsdGVkX18qdKpbu7PiK0/B5Po7EbF3egHy23i0cW0=",
          "cpf": "U2FsdGVkX1+J9jtL+Emn5m36yd25InxJkXrqC+08Il0="
        }, {
          "num_cand": "U2FsdGVkX1+73y71N+BrZHD3lD1xpGqgZxkqwjbyQyY=",
          "cpf": "U2FsdGVkX19IV9EofRlmWoDKt5YaV7VrN7HDYQ5x7P8="
        }, {
          "num_cand": "U2FsdGVkX1/EUTxUBKNSUejD+QNZ5qUv5ew9KCbfOGA=",
          "cpf": "U2FsdGVkX18qIST8eW/HX1cn+wr/6EbhR1OirwLZbRI="
        }, {
          "num_cand": "U2FsdGVkX1//nX5QnXgB8jczaDjSnTWRwkEgSAgT+m8=",
          "cpf": "U2FsdGVkX188r5mJBv3NMZt6s7UTCmfMhsVbxdAOyGc="
        }, {
          "num_cand": "U2FsdGVkX1/Gx42X3pK5N8mIIX2D0ZAbquynhdpnHXY=",
          "cpf": "U2FsdGVkX1/pY7EunDTIEwxYibM1rNVrnTm7Vcc6mPY="
        }, {
          "num_cand": "U2FsdGVkX1+wo+AK1oyGra8lp1BULYM9AtfuUF8jSrM=",
          "cpf": "U2FsdGVkX1/ibilL7D0dFHyeBypiLR8KVYha4faRJ6Q="
        }, {
          "num_cand": "U2FsdGVkX18+dUfPS9iKkJCubBtJjiTqJGyOe9sVzWQ=",
          "cpf": "U2FsdGVkX19100jOXeBpll1rFsKoQp8+96hTJId8PsA="
        }, {
          "num_cand": "U2FsdGVkX1+Qx+DsgiECATFAO2lZHHEOOTaNLj/xtzQ=",
          "cpf": "U2FsdGVkX1+9a/vPt/LEqPT47VP2zeSsuYQRisdd9rE="
        }, {
          "num_cand": "U2FsdGVkX1/T+NF1dUf0Xo5uXj7x0ExQHAEcbzBRrGY=",
          "cpf": "U2FsdGVkX1/s4vv4o4fyQQCqpXkoYyJKTlyZ6Cjqct8="
        }, {
          "num_cand": "U2FsdGVkX1+qYFxpxlsuYW7g1MfB3EioCPGq03PWcMI=",
          "cpf": "U2FsdGVkX192bxozElcanLx6fJTkTq/wNNCHbBhUMIo="
        }, {
          "num_cand": "U2FsdGVkX195QKRH/ff5MKFQe4Fwmp4smXV7HKqIEkw=",
          "cpf": "U2FsdGVkX19EvHqlwp+3mVjsWJD/qpRQqRioN0IhOqw="
        }, {
          "num_cand": "U2FsdGVkX1/ceV/YUykV/YaPg1WXcsKUuIFDpILYmbQ=",
          "cpf": "U2FsdGVkX18UzpTb9yJtkGYynfLgS/zC6M2QYOwmsW4="
        }, {
          "num_cand": "U2FsdGVkX18fsXYhKBpxTqfaVM7nkMeVM3idtuzwGlQ=",
          "cpf": "U2FsdGVkX1/h9omFznIRrhERr023OyKs5BCgkIdAnQ4="
        }, {
          "num_cand": "U2FsdGVkX18QV2813TXvl9RKBompJvPm9VjWceM2pkA=",
          "cpf": "U2FsdGVkX18V8Rze7urZYEa/TXx3jClfM3oueJ9JTGY="
        }, {
          "num_cand": "U2FsdGVkX19Pd3BVBhq6oXD/T3FQcSag4ct69unX+so=",
          "cpf": "U2FsdGVkX1/LxXg+SUC2LNcVCrvlPRumgUEsVRZp34g="
        }, {
          "num_cand": "U2FsdGVkX18gyJvA9GG8Z+EDtd0naHITvHGwqH4doVs=",
          "cpf": "U2FsdGVkX1+TCzbeTpvkqxoAN9c29FoNOeRg7qSTl/I="
        }, {
          "num_cand": "U2FsdGVkX1/bZgUlmJH6+XbYXi04PeMnFaLEofte7XU=",
          "cpf": "U2FsdGVkX19kfB/uARRzornFfX4oa5TSJZH8t7B+b10="
        }, {
          "num_cand": "U2FsdGVkX1/swi1JyJZ1OhhSYQKK3jnpQhZGGuu/jys=",
          "cpf": "U2FsdGVkX1/zQDw4aEXPTCgFUkfzfZuy/SGEgLM5cDY="
        }, {
          "num_cand": "U2FsdGVkX1/aM37yjwg0M39xsB20LqKsuwPgI11rVO0=",
          "cpf": "U2FsdGVkX1+gXXbIUHcbj4/Ip1AtEudfSwayChL9vE4="
        }, {
          "num_cand": "U2FsdGVkX18ynqQBQSGmm0Z2bYJQr8ad3TD/+DG5UNg=",
          "cpf": "U2FsdGVkX1/a/a4QgWESoY3VV2YfJ3joN3lVRyvPI/A="
        }, {
          "num_cand": "U2FsdGVkX1839oMc6wEPHrf9O/I1+D4/NzXTuOv7a0M=",
          "cpf": "U2FsdGVkX18SWcUQh86ppJ+JsQttSgVUIJacVFh6PpA="
        }, {
          "num_cand": "U2FsdGVkX192wRpn/cmT1sNykD/lIZ08RLRtetYmmjo=",
          "cpf": "U2FsdGVkX19/NIy1+3c5D7wfqjIReRwBJPyLBbFcgUE="
        }, {
          "num_cand": "U2FsdGVkX18aQhYj9gL9qK5vmtg2DqUEAYxMPcWALjY=",
          "cpf": "U2FsdGVkX1/8X/JhHk3W5jeUET1KCmklmBXkGGY1YsE="
        }, {
          "num_cand": "U2FsdGVkX1+3X8rupkzCKXw4poxvEwK1yMQdfI0bhwE=",
          "cpf": "U2FsdGVkX195An0KbR1mk1DfipU/Ue/tgZ1Dkawb63g="
        }, {
          "num_cand": "U2FsdGVkX18X4TTDROsxNGYNWgwx1hOWJy4PBU4hsH4=",
          "cpf": "U2FsdGVkX1/s+Nx/VBoI0kecDpq3r2pF/5uUR/oLQr8="
        }, {
          "num_cand": "U2FsdGVkX1/OphydlJtfbFQfhOqWRMM8RY2GRys5O+E=",
          "cpf": "U2FsdGVkX1/dka8d4qMOeWSrVzBLowgTNx6WBLEi9QE="
        }, {
          "num_cand": "U2FsdGVkX18GZPNIa+V/uxxSnWJOYyw9/stLWY9sdWA=",
          "cpf": "U2FsdGVkX1+UtEC02+lG/Z4omenGB6FzoISWFhTR85s="
        }, {
          "num_cand": "U2FsdGVkX1+ZK/3Eio1S5heCmKcZmq145hww90UhO2U=",
          "cpf": "U2FsdGVkX1/ZcPVW48xMIqwFhFkfxjHSxwaaf1/9mEg="
        }, {
          "num_cand": "U2FsdGVkX19DmCGWZE3x21wCywSwXcgaKwwQIEcmNAw=",
          "cpf": "U2FsdGVkX1/c/zlJ3hqhUKoAVQD+J0M9LkM5OxFZvoU="
        }, {
          "num_cand": "U2FsdGVkX1/HiKwZO1Ao+FmpkweR8D+mMs3/PvMLpLI=",
          "cpf": "U2FsdGVkX18Ea3yMPvWj4SIfaYDzTiNlI23+5ZYJK5w="
        }, {
          "num_cand": "U2FsdGVkX1+A+zPNHQuhanzA7UzGKOZ3PAZDW2fiIs8=",
          "cpf": "U2FsdGVkX1/yLwdcztHO6vX0TQ+0gKOYYvo7gf84YuI="
        }, {
          "num_cand": "U2FsdGVkX1/PkP9IeD+/3QnjLu5z+2zwqwYHm2p9DNE=",
          "cpf": "U2FsdGVkX1+1JqDY8iQAPpvTLm/yzTjpoKeXK2M6MI0="
        }, {
          "num_cand": "U2FsdGVkX1/4SCobSNTwvjucGCxSfz5jF7JYccgAOKM=",
          "cpf": "U2FsdGVkX1/F0crgDRrBYMEphkj/W9BBZb74v1gRlSM="
        }, {
          "num_cand": "U2FsdGVkX1/CmC9rScX/dubsmZ67AF0EiHN5a/yfGfQ=",
          "cpf": "U2FsdGVkX19Ps+Jb0C8RBLR/255f1+v4k9DtJz7Ugxw="
        }, {
          "num_cand": "U2FsdGVkX1/uG/zAuJHfZLPT1cv3K+06aczCFajqOTg=",
          "cpf": "U2FsdGVkX1+5k9m81p1w2k3aHVJy+nfFJ0Wq4AyqVMQ="
        }, {
          "num_cand": "U2FsdGVkX18bZ5Jecu0QMSolnIwAj45djG41CQy70uU=",
          "cpf": "U2FsdGVkX19jOxnw8BcRI1Pti7QoyGfuBTLHU7oraGA="
        }, {
          "num_cand": "U2FsdGVkX190zyaS9wB4ZgZRAgyyCuH2XKKamXYLdKw=",
          "cpf": "U2FsdGVkX19qyFXraLpzlP/QbNlP6pzOEDn6MMEoKmk="
        }, {
          "num_cand": "U2FsdGVkX1+vKQnLSVx2aFk8UCJ0eXXsWqHn9n7FYWM=",
          "cpf": "U2FsdGVkX18rWx6Xc4G9EYG9feyilYYBlH0jQ8ObLmQ="
        }, {
          "num_cand": "U2FsdGVkX188oxbhgPihi/gg+utlyFAwLRtYg688dE4=",
          "cpf": "U2FsdGVkX18DgmdPy8vPmMIKyTdPv06C60NebV4PetM="
        }, {
          "num_cand": "U2FsdGVkX18DhMeXGwGE/3xJBH7DlsMfj3jSRH4PLFw=",
          "cpf": "U2FsdGVkX1/Q9SvlftzCuIepekRMXWFKjPK85W22ln8="
        }, {
          "num_cand": "U2FsdGVkX1+/0DUih720NZ/oeNmetGoiacPvpHLb8pg=",
          "cpf": "U2FsdGVkX19FSHCF/25hq0XuLXwABLEWswuPDTaiIbk="
        }, {
          "num_cand": "U2FsdGVkX18aTdlASXDx8A2Se8cLnEgujfFsUMSoaTo=",
          "cpf": "U2FsdGVkX1+r+MwwR3UXFrqVYapxIUAQAkfJpdBiknc="
        }, {
          "num_cand": "U2FsdGVkX1/KRyygNtuRuzJL6IIyzBb+HcNn2EVxoYo=",
          "cpf": "U2FsdGVkX18k7TRiCj7zjIFVkWxN4Q4ZcrbTN5B8jVA="
        }, {
          "num_cand": "U2FsdGVkX1+6piKb0vgr+r5iXcDV4uTNwhs95j9uUps=",
          "cpf": "U2FsdGVkX18eVcuDFiVglDw5C71U2W47tG6Airxs33s="
        }, {
          "num_cand": "U2FsdGVkX19xc9qyOcqbDiVaysREWPe2flk1ru2uBFo=",
          "cpf": "U2FsdGVkX1+JyVrwnueQtn94V3WzqmxpZdA5he0C7l0="
        }, {
          "num_cand": "U2FsdGVkX18543f185mEeAv2LOor2YnICtAZfrTZ2h0=",
          "cpf": "U2FsdGVkX18tyWGA8pXW5CKIioE/4e9mjjny4lmKoqk="
        }, {
          "num_cand": "U2FsdGVkX19CRSx+RT4YCnoEyejADKymZjSzSv04WqA=",
          "cpf": "U2FsdGVkX191tIGVPn3X7IHR9zQRwKnMEx5kxo0DAy0="
        }, {
          "num_cand": "U2FsdGVkX1/klXnCrBdnW5BvvNjPp8OlVhry3AUqXuU=",
          "cpf": "U2FsdGVkX1/cdBP9eKSShEzg9Ro8aHAtQaHaAs6dF14="
        }, {
          "num_cand": "U2FsdGVkX18JIUXDVMCps3T/pFZZxZPi9iLHz9CS/Uw=",
          "cpf": "U2FsdGVkX1+E65cXYkTcjnhDpPPyia7ucBBV0MBK/To="
        }, {
          "num_cand": "U2FsdGVkX18VIXF6xipgIjJF8InXC9wA4hQu0yKLioE=",
          "cpf": "U2FsdGVkX1/9agRiI5eAldnki/7PSIMJgdNq24m0iQ8="
        }, {
          "num_cand": "U2FsdGVkX194kMaIczePfQCp8PyeTq6Ew98e46Zqojw=",
          "cpf": "U2FsdGVkX1/Zrye8UqhlyEDJXyeGppySkTAhCA5GsIM="
        }, {
          "num_cand": "U2FsdGVkX1+egF78GOheUOYG6Ne2Ob/a5QF2OnYdivI=",
          "cpf": "U2FsdGVkX19a3+6v0qQk3Ndo6kgV0PNbFj4DFpbA4Tg="
        }, {
          "num_cand": "U2FsdGVkX181Fh7TOXguWJArAESZOODOHAkGydXlTPs=",
          "cpf": "U2FsdGVkX1+YoV4xPaD9guZqmAjFBUeb7JdPWSNegvs="
        }, {
          "num_cand": "U2FsdGVkX19j1sNNbavn5AtykhyzONrthAYx6Vdlhcg=",
          "cpf": "U2FsdGVkX1/SgtGLMMEndCmK8ONAaH7JfyjIsfRTWM4="
        }, {
          "num_cand": "U2FsdGVkX18coIgXDjT5Qc8BQ96Z7H4Tc+UWPcj6+kM=",
          "cpf": "U2FsdGVkX1+sfXkpomDR7r6h6CAdriS7Um30/c2y1DI="
        }, {
          "num_cand": "U2FsdGVkX18KPgFU9wnsTPm3uHeaqAJdu+6LNsOILzQ=",
          "cpf": "U2FsdGVkX1/Htj5kCKVft0fScZ9PcJqGtVngPUF/j1g="
        }, {
          "num_cand": "U2FsdGVkX18UPIRIlNZHC0BYDKmjgbXfPmAX0uITAT0=",
          "cpf": "U2FsdGVkX19QqV/tTVEBiScTAdSHMMuZEjvTTWXW76Y="
        }, {
          "num_cand": "U2FsdGVkX1/2Hb5cXX6mbsaSqEiMzl0bO+QGgd5HulA=",
          "cpf": "U2FsdGVkX19E42oF7G8YYG1TCDzg57ioB5Az+i29VBk="
        }, {
          "num_cand": "U2FsdGVkX1/OOZKwbvmEiolmRH2bORndp8xB83mdiFs=",
          "cpf": "U2FsdGVkX1+TJBMJSXZnQEyJ5rIpeEcezaaNDlbs8Eo="
        }, {
          "num_cand": "U2FsdGVkX19n0d+IxMHNU2QMgTdSB3ycJVoin4N4ot0=",
          "cpf": "U2FsdGVkX18FCRgcXAJXf2011nAdyVfPIDx5KB2GJZc="
        }, {
          "num_cand": "U2FsdGVkX1/I+QtVFe5SF1cOp38EFllP/1myQ1c819Q=",
          "cpf": "U2FsdGVkX19ScBuEu6BGMwNd/0ZWhVp0hGsdMjmZ5+c="
        }, {
          "num_cand": "U2FsdGVkX19evIzseIIXCAwB7Zcn23ns1UCZQA63tw8=",
          "cpf": "U2FsdGVkX18i3XC7B1Kev8avDYkerfkBMCFHl7W33dE="
        }, {
          "num_cand": "U2FsdGVkX192+HSVNWttR/f9KHPPmHpHdYrZFcW1ne4=",
          "cpf": "U2FsdGVkX1//a7ZyvoofrGbzCjyF7l3dZgwnGIsAfnw="
        }, {
          "num_cand": "U2FsdGVkX18qHt2IGXjSIyvhTp507yGsGompVO+fn5Y=",
          "cpf": "U2FsdGVkX1+PWipmQ7w7aABwKRV9Gd8qS0VD42d0XKQ="
        }, {
          "num_cand": "U2FsdGVkX18WcJnZsMckMbu5W06e+gcfoggqc2pT9+I=",
          "cpf": "U2FsdGVkX1/j4493SUUTaotj/Nhc2b4oKb2xfnlmk5A="
        }, {
          "num_cand": "U2FsdGVkX1+9XRzb6CvrYrw4AyR7nKY796bXBeAWQP8=",
          "cpf": "U2FsdGVkX19blCZWExNcy0BL3icwIYtt/2ns1qPa8gM="
        }, {
          "num_cand": "U2FsdGVkX1/8nHayB02wTZsewOzXx2wK6+K/y9HrEGE=",
          "cpf": "U2FsdGVkX19DT7qoTnXA7mTHiUy8JHlXftrjrIC/RqA="
        }, {
          "num_cand": "U2FsdGVkX1+XPJ1ijX+easQJryPBbslt3dA1LuwSAg0=",
          "cpf": "U2FsdGVkX19lLtekcRtbVDjosOz6cITycNPXH7gXPjU="
        }, {
          "num_cand": "U2FsdGVkX18JT0YiZQqVdbeDcXPYcrgrk+4/hLYgNN0=",
          "cpf": "U2FsdGVkX19zaUk2a59YvfOmBnY7AM2oPJYO8LZdXxk="
        }, {
          "num_cand": "U2FsdGVkX1+tywh6lMrn8aFXj172bZZkd7chMoEXNsM=",
          "cpf": "U2FsdGVkX1+dTWx8vn7SJ5EWJfwNDxmAqOZTdflflyQ="
        }, {
          "num_cand": "U2FsdGVkX1+2eqXB1EkjxFmmYRG6Okzp+A60GlUwVO8=",
          "cpf": "U2FsdGVkX189Nf6y/K99tL9tOCLZnD29jLIDbddjdyY="
        }, {
          "num_cand": "U2FsdGVkX181jDQQvIkSLen8bMJxNd8iJmuwxYZGxEw=",
          "cpf": "U2FsdGVkX1++LwwzRHaGY+yiuadjTICAYrAnh8asd9o="
        }, {
          "num_cand": "U2FsdGVkX19ACKPjSYVdBqEFgrkOgDze2Jfe2ongWsI=",
          "cpf": "U2FsdGVkX1+scgjHiRe41j+YZiWhHeWTKyEQGUD/ZRs="
        }, {
          "num_cand": "U2FsdGVkX19loeI8CfR12qcan0gq/67XAqVFAIsZflg=",
          "cpf": "U2FsdGVkX19rDVGidYJ7QNiF+lgbd0dC3ho0AM9xSW0="
        }, {
          "num_cand": "U2FsdGVkX18E2baXcQWpyYh7q3VFW6V1ZngRi9kWV7k=",
          "cpf": "U2FsdGVkX18duUqe9De5xKr10Z/moqn7IfAB3Rxw5XY="
        }, {
          "num_cand": "U2FsdGVkX18LIG+WVvmhIxNFyB2IsHqYqnxZLqjouis=",
          "cpf": "U2FsdGVkX194qslHA/7xbziY/gUm633vepgw7Lr1aJY="
        }, {
          "num_cand": "U2FsdGVkX18CE8oZzbxm0DFnxYX5pVxsmmmtIFMpUQo=",
          "cpf": "U2FsdGVkX19Pcqg1pi5S132hFv3VkzrJuWfWUkcBYTI="
        }, {
          "num_cand": "U2FsdGVkX19wP0kmNinv4490I3YafI3zkEiCEDkzG3g=",
          "cpf": "U2FsdGVkX1/66hFUBlTRWAzHN7ez+hZ1IJzFLdA1cIA="
        }, {
          "num_cand": "U2FsdGVkX1/YuVXP03gYkVN6G0biXqyZGbK/nA3FUhs=",
          "cpf": "U2FsdGVkX19F7VGzoE6jsu3bFZVZ8WtWYtc5QW58khY="
        }, {
          "num_cand": "U2FsdGVkX18b4RMFbFvkQdVeeJ4YOWgqhlZeREztmuo=",
          "cpf": "U2FsdGVkX1+z1Mu6kDrjgoJ1cZWc1/9Njd7BYLXJryA="
        }, {
          "num_cand": "U2FsdGVkX19mkZJhBJUtWWT8jG3An4V0JNXh0FgPkSI=",
          "cpf": "U2FsdGVkX1+rjvuAkLy39XXyyU2f0KR0QBufaqC+2uU="
        }, {
          "num_cand": "U2FsdGVkX19nLo5xcbT8/Aj7l77Rjsa0M+zfIKWeD8c=",
          "cpf": "U2FsdGVkX18U9cR9eEYifq8jI3XzPA2FLmYrL9OuGGA="
        }, {
          "num_cand": "U2FsdGVkX19m+zWWUQcDF9PnydXRboaMgR8JoEdKiSE=",
          "cpf": "U2FsdGVkX1+gvGBC/oDG5E0o0UR4H7raZU5tMoA/Skc="
        }, {
          "num_cand": "U2FsdGVkX1+26A6lzzrJxSgbtl2kQf/EPQPuE5qB29E=",
          "cpf": "U2FsdGVkX18Q8T9v4XmNIlqFly5gfYmzZfGpBY9S2KU="
        }, {
          "num_cand": "U2FsdGVkX19QnEQIuC3QGXqJd85P6Rpwdqv3ljapBpo=",
          "cpf": "U2FsdGVkX19pY5xo6duAfnX6La83sjZCRGa8zzNZrsc="
        }, {
          "num_cand": "U2FsdGVkX19le/TXJcjTelmVjl/AJoxpalZQKtxIGIg=",
          "cpf": "U2FsdGVkX18hp21I18e0HZ60hli4BCdzsQY+/zWWjos="
        }, {
          "num_cand": "U2FsdGVkX1/rnN/mveXQ9wrttCkqmvQt8ZoO3cwMQMs=",
          "cpf": "U2FsdGVkX1/uxz4IEjw5e5UTnSaekyIpPEU8AWjARDw="
        }, {
          "num_cand": "U2FsdGVkX18O/2SmAd7AMl3vT+p+8Xf/8x+SspScZBw=",
          "cpf": "U2FsdGVkX19MGE73KhYpNsm+AozVF094Ief1ClL3pbE="
        }, {
          "num_cand": "U2FsdGVkX1+/5QgVZrBL2zQkvURzuOXykxf9X743xck=",
          "cpf": "U2FsdGVkX19AEviy0A0ZU92Pbxpg0yUNfJWV9C5OHyA="
        }, {
          "num_cand": "U2FsdGVkX1/89RgYIIcPOOX2l6xF/BY4U9Z+XgZt6G8=",
          "cpf": "U2FsdGVkX18Jw5uBfCWCh0mVqlTWhKT8i4wd8OXrEf8="
        }, {
          "num_cand": "U2FsdGVkX18BMAHU4QHzVC3V5RdSxovFWOpIiDuyPLc=",
          "cpf": "U2FsdGVkX1+dF5WxaNd3lFMUbYohbUdF2VuyndRbKXg="
        }, {
          "num_cand": "U2FsdGVkX18/Id/JgJvpQQ0Snv0igobiBMc6AhtNHAU=",
          "cpf": "U2FsdGVkX1/8j9gaMvX/VtrDG1uUezn8RZ/2gyy8wlk="
        }, {
          "num_cand": "U2FsdGVkX18/OFUJo4ZKJBl/JLogkKjt17QniyPahHY=",
          "cpf": "U2FsdGVkX1+TFZsJ07wWhyUuPwAR+yLB5G7vddFNE9Y="
        }, {
          "num_cand": "U2FsdGVkX18eH/RVd3Nyc2NUeqbUkVT61+cwNculgIE=",
          "cpf": "U2FsdGVkX191F6H5hCFmmE8CabKqx0blDtYqpDUI9wY="
        }, {
          "num_cand": "U2FsdGVkX1+Ewxa60RsbP8rRh4FUjMh/i7oCqYgwm8g=",
          "cpf": "U2FsdGVkX1+5lAbXXbz2cu4T7PEkFvmx5MXndbMZ59M="
        }, {
          "num_cand": "U2FsdGVkX19vUOHodHFa+eW4bfSssWgajD3/Q8C8kcI=",
          "cpf": "U2FsdGVkX19Hk7LA8oBATBqt+s8LOJHnUAJsN2RwM0o="
        }, {
          "num_cand": "U2FsdGVkX19CnDH7OEIIEIDJAlB3Efi8ou4FbCY1BvY=",
          "cpf": "U2FsdGVkX1+exznJw0+lvdSQUi+EGrVOllp/igRJAU0="
        }, {
          "num_cand": "U2FsdGVkX1+3eiHXWsBJBXOhlP2e+U92Ql5Ah4azmZo=",
          "cpf": "U2FsdGVkX19iOwoG1y2NBdKLBprwBrZ8/XXes0LpbkI="
        }, {
          "num_cand": "U2FsdGVkX1+mXo9oZHt9GSNHjBSUZqliT1EJhmmzZdw=",
          "cpf": "U2FsdGVkX1/5D+xunKzQWfAbHdGZDAriRmUidGazyHg="
        }, {
          "num_cand": "U2FsdGVkX19K4azIp4+lCYfdwmWmLVodngN3FbUYDb4=",
          "cpf": "U2FsdGVkX18wC2atUbPQWHCAaG/41QzbOSHslVlEJ5w="
        }, {
          "num_cand": "U2FsdGVkX19/t1uoQDVLDxw9KfmyeR3Bd7/fqxUYH+o=",
          "cpf": "U2FsdGVkX1+q8fjNfIW2DLyl6FFYUV1um2AeRIKuO+U="
        }, {
          "num_cand": "U2FsdGVkX1+19q97MY6jmxeI+Ta/9sFFfT9978/ukik=",
          "cpf": "U2FsdGVkX1+6cn6tUWlz2Laz2X10gE2RHUepMu9xAjc="
        }, {
          "num_cand": "U2FsdGVkX19BytV/MB8r2fUH/3BAWkPrDc8qflawifE=",
          "cpf": "U2FsdGVkX18+IX77VOO0xm0lqCqJn/XkTJ3PLlR3oMI="
        }, {
          "num_cand": "U2FsdGVkX19vtmRY/vJptNh+4Zbzn36VLRDozE9OH8k=",
          "cpf": "U2FsdGVkX18tHOmmR06/IR758djNc1lkq2EM24P33bU="
        }, {
          "num_cand": "U2FsdGVkX18q1pIROAWTSGawLcH/d+GFB+QEVS0sMAU=",
          "cpf": "U2FsdGVkX181tH8iDRlhUwqq0FpjUuYB5mLSX288mOI="
        }, {
          "num_cand": "U2FsdGVkX1/PBsD7v0wgYECYAhcRrifsiIPhYmxq0kM=",
          "cpf": "U2FsdGVkX18dsCTtf9+7gPkNA3uEZ6KGQN9TjgXjHyU="
        }, {
          "num_cand": "U2FsdGVkX19+ogC6CgKhz5IKS8nXdRayA3sEdL2J7ss=",
          "cpf": "U2FsdGVkX1/uC8uflECSt5mBMFSZ4AGtT6MYhZ8KcoE="
        }, {
          "num_cand": "U2FsdGVkX184LbBvJ12PGNd5Q0DBg38srk1w0P/0grU=",
          "cpf": "U2FsdGVkX1/Xh4RrVVRPuxXR4vtGqz7Mfcu+gQpD7WQ="
        }, {
          "num_cand": "U2FsdGVkX18IulQa7TXFPOY9Hn3qH3WY0fP+Nzn9NU0=",
          "cpf": "U2FsdGVkX1/344o6czEU1kjWnliqUVFfGW2TuTkNjfY="
        }, {
          "num_cand": "U2FsdGVkX1+qpVj2o7wwCgvuBz+OxUhVlixoWNKlxko=",
          "cpf": "U2FsdGVkX1+Xp2xunxVg9IRNULSHCu88yOSlNfgveTI="
        }, {
          "num_cand": "U2FsdGVkX18o+5+gPVmuWY/cTWRj21TnbFrNvuccjoE=",
          "cpf": "U2FsdGVkX18RCe+cAWhkmY3m0zHFdWqJfgo7VvkmXoI="
        }, {
          "num_cand": "U2FsdGVkX1/Psp8c2mSKOi9MlufgtAUHpi5hCf+YrCs=",
          "cpf": "U2FsdGVkX198RRu3Cg7IBcpZDm/6ext9Rg8Flm9w6+M="
        }, {
          "num_cand": "U2FsdGVkX1/3IyAzBmRQrrrxeOXKgJvbkkO1XvqgS4k=",
          "cpf": "U2FsdGVkX1/dNPMSoJQAHL7XZNYmAcbTjRFjpEHNomY="
        }, {
          "num_cand": "U2FsdGVkX189YKGqKbCdJI/0S0DK+VFz5oEsD76uQjY=",
          "cpf": "U2FsdGVkX180wk7vCaF0UbuXHZOKb7cmxePMx8c2HG8="
        }, {
          "num_cand": "U2FsdGVkX19Nw3NFaDGEffgShImRg9L+4dA2JQEYxmM=",
          "cpf": "U2FsdGVkX18jbsh4vsfvI1eVWp4apItdpODPEO0cyd8="
        }, {
          "num_cand": "U2FsdGVkX199vTZMl+RuiviaRA9I7lDmQfD6zW7DxfQ=",
          "cpf": "U2FsdGVkX19QOVTYElmQNupJoxRqySuqStTqFVYVteE="
        }, {
          "num_cand": "U2FsdGVkX1+2stFyEmfGNEax3ta91ZqqQugfQbXN3LI=",
          "cpf": "U2FsdGVkX19PtuZ/PivRE6BrEHS/f/zMhJgFuZJRA5I="
        }, {
          "num_cand": "U2FsdGVkX18v6f+m1vPDYDuCUkJncDLO91CqGqzNW5I=",
          "cpf": "U2FsdGVkX1+/pbGjYgRdno9Hmc9+ipBDxq4dkcxkvCI="
        }, {
          "num_cand": "U2FsdGVkX19Jn9uPZUFZQ5Rj1ntPbCEK3SGQdInyoX0=",
          "cpf": "U2FsdGVkX1915EzugQNNKIcykVTk+/ORzjC6szZjcnw="
        }, {
          "num_cand": "U2FsdGVkX189PdKmFjjvIaYiL53+TsUuR6gthS+b0OY=",
          "cpf": "U2FsdGVkX1/aZJGHDt30LWi1nwkO9AOsJoQs3vhc47g="
        }, {
          "num_cand": "U2FsdGVkX19ZmprV4h6fv+AFigPkbpSH2n3u9vnmY+c=",
          "cpf": "U2FsdGVkX1+9E95qz+mou5XFNtk+nOW4Pktso7uD2+8="
        }, {
          "num_cand": "U2FsdGVkX1/dLGAkjQwew6lbMZztWCS8jim+aSIlLWU=",
          "cpf": "U2FsdGVkX186hUR497UEOs/ejvwV00jk4AsLBJ6ODws="
        }, {
          "num_cand": "U2FsdGVkX1/0D2oECkrzhSDLH/nBTRAA392Zpx1BawQ=",
          "cpf": "U2FsdGVkX18UhJxxglLJVU8O7ZHj2yVFj6sboN/50CA="
        }, {
          "num_cand": "U2FsdGVkX1+LuAJ0sjW1QWrbTO4y17RnUEF9rFBk4T8=",
          "cpf": "U2FsdGVkX19/D344oqaeLwVOCoZb2c3+WU0TLLITe2I="
        }, {
          "num_cand": "U2FsdGVkX1/Mi37suE1GMdnincGZ/929XXiDL9YLFsY=",
          "cpf": "U2FsdGVkX1+gV8aMysKudpoQCnEMbqle465Au3XvV9M="
        }, {
          "num_cand": "U2FsdGVkX1+vZ7wRFKmxiMnJ9nOprV/UqzPOXjsZDng=",
          "cpf": "U2FsdGVkX18PisUOaAVDKuVI//ItWLVbYpu2YDLdPio="
        }, {
          "num_cand": "U2FsdGVkX186S1L/CkB5vpFVrcz+j2gEZ/lrOqghRsI=",
          "cpf": "U2FsdGVkX1+mqNAX+RdbyU4nI0+Qthz3p30wjp1r8eA="
        }, {
          "num_cand": "U2FsdGVkX1/bhljl/6NQRjsJSx/TCYHtrice9qcXLbo=",
          "cpf": "U2FsdGVkX1//0ykP5eQd4iwhmVqywwbavNjwwhYNpo8="
        }, {
          "num_cand": "U2FsdGVkX1+KUixwOjL9LpAazwJnm0uYaefxCsZb2jw=",
          "cpf": "U2FsdGVkX1+08iOpoHqkezjKyynLM5MBGZvMaK02jRc="
        }, {
          "num_cand": "U2FsdGVkX1/s7IQE1BqdnwS7Gst5F20YzZIGUE3nzWc=",
          "cpf": "U2FsdGVkX1+OrxF6H9ZPIlKXKeCHdXx5fxZxOH6U72U="
        }, {
          "num_cand": "U2FsdGVkX18Ji9p7x+eY5ym19ZUa07aegiWTdilxhpE=",
          "cpf": "U2FsdGVkX1+sEf7AakplSG6TEq8wXkEmDlUQLx45TUw="
        }, {
          "num_cand": "U2FsdGVkX18HDIzqqk3WsiUBCI5zMfjPTQfo3huJpD8=",
          "cpf": "U2FsdGVkX1+PWj+cnpq8MlFRKQkKon+bJJyRZ4BvNhU="
        }, {
          "num_cand": "U2FsdGVkX1/irQv+M2D3ra9Q1flUjddtAhfKCcnjlq8=",
          "cpf": "U2FsdGVkX19QABBXrjTJrJfx0U3EuH624T+Tn56vnt0="
        }, {
          "num_cand": "U2FsdGVkX1/QCDKuwNXZiX7+iIRZ0WE+NejD3zEUydY=",
          "cpf": "U2FsdGVkX1+GC55Jjyu0oJ5NH8ik1Gk74m3ZyUtb/+E="
        }, {
          "num_cand": "U2FsdGVkX1+DWWBIZrt2ScQovhOD7urbFgcokmgx3I0=",
          "cpf": "U2FsdGVkX1+rwZ9X0aKjnGIdEFI+0/LGT3KaN2djEE8="
        }, {
          "num_cand": "U2FsdGVkX190jA4Nv0tiUcF96sWpVoaaPkAEP6mhuT0=",
          "cpf": "U2FsdGVkX18OHDLOmc9c6yYgpPsaZ/korYbZI7GYZLg="
        }, {
          "num_cand": "U2FsdGVkX1+n8lEP+I3UHNmx+igABt6XGNMGjaGw/xU=",
          "cpf": "U2FsdGVkX18k3MjGD4fnB9+1/RS0XEtY5er78KOjlZw="
        }, {
          "num_cand": "U2FsdGVkX186El5jnkH7Bch6PHXsm9tN+8XRauBmc1k=",
          "cpf": "U2FsdGVkX1/Yz9/MHc54UGXIpZF1PpfTPsx0h+BAfnY="
        }, {
          "num_cand": "U2FsdGVkX1+7V/YI3ZTrKa0GHoAsKg0RiGRCVZXGiCU=",
          "cpf": "U2FsdGVkX1+IfNdIxKRAGUkYtV938MSpHKkRv8QV/FM="
        }, {
          "num_cand": "U2FsdGVkX18OFCUBPq4+M1SDvPFuhzhk4VQfas8Ln+s=",
          "cpf": "U2FsdGVkX18J1E9JBoKtrPj//t4zoxh03h9gc3+RuCE="
        }, {
          "num_cand": "U2FsdGVkX18RR6l/ySzd1hUJGeFJ73CrJA0zkNdyp2g=",
          "cpf": "U2FsdGVkX19HH78XSQp700v2DhHHPlrm3luD4CYdvIg="
        }, {
          "num_cand": "U2FsdGVkX19wY3flfm1ZdROPJhWnT5IwydhmFEZcCiE=",
          "cpf": "U2FsdGVkX18cw8YdD39NHxSicdiPqD02AFs5TlJXjGc="
        }, {
          "num_cand": "U2FsdGVkX1/pn85qC+vtFNC8dP0afwQGKUypAupCijM=",
          "cpf": "U2FsdGVkX1/oA1laytU8wrjwMK4j1YgMPcQWqUN9I0k="
        }, {
          "num_cand": "U2FsdGVkX19pg3yo/mXSpViwmTfWJJ2A9b0di3709E4=",
          "cpf": "U2FsdGVkX186k2bfnK2t62ZG3Tvs+rRZVLc5tzMcpaY="
        }, {
          "num_cand": "U2FsdGVkX1+Y1yJawfbpc0FPXWZtDMGmSPggqiomEC8=",
          "cpf": "U2FsdGVkX19NP9LWl0kzqsQgzDcg33MyVvWkwt6eurg="
        }, {
          "num_cand": "U2FsdGVkX19aQNWkiBPMuExxeNRNoUSxs7s6HkB6nQY=",
          "cpf": "U2FsdGVkX18eU28IB5JKPbgNlKwUFZfgZBv2Ga+hcqQ="
        }, {
          "num_cand": "U2FsdGVkX18bDSf8s85Yi38BnhZ8t78oRwz4rLM730M=",
          "cpf": "U2FsdGVkX18LGSPiL9d7cdrCIEBPbUybIKvbvJXrKLQ="
        }, {
          "num_cand": "U2FsdGVkX1/Znt4E+rNlbBqDDRfz2vGuNw19w3zESfM=",
          "cpf": "U2FsdGVkX19DOFwsF5eYq7j/IAShw0z8NJVj8TczYxI="
        }, {
          "num_cand": "U2FsdGVkX19sG0HNNs4875c0NqkzAWGjebL1phUhgyg=",
          "cpf": "U2FsdGVkX18ZgMuEk2EebiThJHoq62ASyqyg6dj9x2U="
        }, {
          "num_cand": "U2FsdGVkX19GnukCGTp2BmqOl6lK3kGpktXHmNLs3wY=",
          "cpf": "U2FsdGVkX18YkYI1Pd4ZS4wEjncW341moHZaUxVfZ94="
        }, {
          "num_cand": "U2FsdGVkX1+G+vrwz4psCNnKfychiE1WtjsdLM9jQwI=",
          "cpf": "U2FsdGVkX1/MwSV0+V96Mpot0nUT/IsY8tyUG7zNC9g="
        }, {
          "num_cand": "U2FsdGVkX19TSyKNQg3w139otxBTXHLQ7X5lMDemSHo=",
          "cpf": "U2FsdGVkX18eaK64XRtur2ET/7aKO1bEDaE0iMnLuU0="
        }, {
          "num_cand": "U2FsdGVkX1+oWRw2CSs4ppsNj0RNJvSaXQB4oqwFCVk=",
          "cpf": "U2FsdGVkX1+t6bRqb71lOxp3KUGwr+3LtST3BNKPYyg="
        }, {
          "num_cand": "U2FsdGVkX1/Xji3mDqBCqz4b7nIWnTOW/h4hpAXGslc=",
          "cpf": "U2FsdGVkX1+x40KJa1s8P6PM/rGUyVhm2aRd7YJ0n6c="
        }, {
          "num_cand": "U2FsdGVkX1/L32HPE3aPpi9XwpxchglywY6hYgYgteU=",
          "cpf": "U2FsdGVkX1+qa4CDGOx5oGmtFNZT1RCykwgAHOdtKDU="
        }, {
          "num_cand": "U2FsdGVkX1+vwmKubR57YeP2ujGrtQ4gf3S/4k6tZK0=",
          "cpf": "U2FsdGVkX18oM7BnLox63dgx1+CjyJRYXwMYony0yxI="
        }, {
          "num_cand": "U2FsdGVkX1/mrDi/SlHGhEzY+RIdXxwsRPmsDwrumaU=",
          "cpf": "U2FsdGVkX18obT0UVwIkFejGsoFJD6bX79moF4NCZ+s="
        }, {
          "num_cand": "U2FsdGVkX1+m7xOcVs+Qg4jT/85Sb2CWxCGrR0ZIBUg=",
          "cpf": "U2FsdGVkX1+eSxrUm5NYRg8CwGfQ1yaYDy5Aoc/e0D4="
        }, {
          "num_cand": "U2FsdGVkX19IoRwPYTek3AM1VprGHrISNkb2MG2A30o=",
          "cpf": "U2FsdGVkX18I5UycM4ywD+klveGGPO5rYWs47eR4LIM="
        }, {
          "num_cand": "U2FsdGVkX1+rXUGkdX8isJjmcPiXBBPb2htSpGUkNDE=",
          "cpf": "U2FsdGVkX19F4kvf8GRij4uB3Q88NLOaJnT91N1rJ/I="
        }, {
          "num_cand": "U2FsdGVkX18c0Vg8tjsEEBPMH1gocQPf6lKiJ9eQoLg=",
          "cpf": "U2FsdGVkX1/1DCBZKuQ2R3TsoYmCiwvAXcL2j07ob88="
        }, {
          "num_cand": "U2FsdGVkX19Uue9r3ixQhwXNN0PG4lDrWrMoRKO6vJA=",
          "cpf": "U2FsdGVkX181dL6nx2Br04uM2W1zXjsqD9ouqh7qic4="
        }, {
          "num_cand": "U2FsdGVkX19kKOVqFZVQyyNtFy4w3K0cm+xiK0lEeYU=",
          "cpf": "U2FsdGVkX1+hF5PRumFH7cYnMlWZmTmBVfeDF2GPmGk="
        }, {
          "num_cand": "U2FsdGVkX1/eaUlzvbowNTg+yalZ6lrXxiQ/ozTEx7s=",
          "cpf": "U2FsdGVkX19cWmU2pB/jZWF5pxf9agjEzeMvPzy0fTU="
        }, {
          "num_cand": "U2FsdGVkX1+4mq6SL9d4q/7/Zv8YNH9Bcw2JMleAydA=",
          "cpf": "U2FsdGVkX18SEeYX0NcI3bxoIoqhd+XZ2X1jE5HjsPg="
        }, {
          "num_cand": "U2FsdGVkX1+3C301UfcuJjZNV03f058dutXUe2vnYjU=",
          "cpf": "U2FsdGVkX18crg0bth2pPGQe46O5w9Yo+WWjNXtX0Pc="
        }, {
          "num_cand": "U2FsdGVkX1/wNObakfKjW6bfcAWjtDeKZe4+D1EWRps=",
          "cpf": "U2FsdGVkX19/vJRobyyRf4dVezvFGT9oGq5q6VzBE5A="
        }, {
          "num_cand": "U2FsdGVkX1+5sJC/g5dcNYos4UkGi6p7BgWnherQkOU=",
          "cpf": "U2FsdGVkX19R/A/hmGpeeuavpf4Ko/jbBRB7C7ipoog="
        }, {
          "num_cand": "U2FsdGVkX18DMB8YtAmCn6YJ5D6CAtJ/+HGscQek2CI=",
          "cpf": "U2FsdGVkX1/5ipeRxHG03/S/wYoC9AKpwcjg7pzU1IQ="
        }, {
          "num_cand": "U2FsdGVkX1+SLRXHL+TlMrwFdiKg7v7POVMmgUKRAQQ=",
          "cpf": "U2FsdGVkX19LsHRHXVHvytJtQ8MDTW/j0qkFWE0cpFE="
        }, {
          "num_cand": "U2FsdGVkX18yLgZ2UZAfTNV48Zo3pnv+fq9r6t2MdGk=",
          "cpf": "U2FsdGVkX194dtI6r6AKx/h++IehhaUqRvlV5c9/4SM="
        }, {
          "num_cand": "U2FsdGVkX1/Tf7IOdJaro9fI42305BhKDHndHIUYjxo=",
          "cpf": "U2FsdGVkX1+L6VorXPJfM35Ewu82H1k8vbhbYeFGLGM="
        }, {
          "num_cand": "U2FsdGVkX18cuPO8FnlIkP6SQGhgvfjTMJupFj8/9BY=",
          "cpf": "U2FsdGVkX1/Yt9MwWR/UGhgM14o06yDRjDplM906RvA="
        }, {
          "num_cand": "U2FsdGVkX18pEzVQgy9scniS7iMvoS0smi/+QVB67cw=",
          "cpf": "U2FsdGVkX1+O8p+xtgRRm15Nht8LLRtcm1d6o6hawJs="
        }, {
          "num_cand": "U2FsdGVkX1/LVLEkp2TZA1MeTGzQyj8t3E6x6sdlBTg=",
          "cpf": "U2FsdGVkX18BHSGjuI0xXgDy9ZCTIy0kECt+fUYCSxI="
        }, {
          "num_cand": "U2FsdGVkX1/ZWsBePKtslz/abdKfC4jmC8vzsuQVaus=",
          "cpf": "U2FsdGVkX1/WH9+6/Rxrytqki2GaiUHnivtz2KbBX18="
        }, {
          "num_cand": "U2FsdGVkX1+Z3DnLS+oe9S4EaTTJllHzppmHsKhUH68=",
          "cpf": "U2FsdGVkX18HBWKcRHnlbHbIiybwHHZG6hk5LN6y92k="
        }, {
          "num_cand": "U2FsdGVkX18vhy10DdL9qMNMv6mtuIdnZosL5C322Dg=",
          "cpf": "U2FsdGVkX1+FUCUl4GAm9HkY1v+w9Oxsa2fHhdtf/LY="
        }, {
          "num_cand": "U2FsdGVkX1/Ihfb8M5MOQi4ynu6Nt8rV31SUjWCguao=",
          "cpf": "U2FsdGVkX18p0jabk4CyZpEQPTL2fy9Pj65y3kmWM18="
        }, {
          "num_cand": "U2FsdGVkX19CIwGvrHjZio8bgPjvraMXPA/xRpvBj3Q=",
          "cpf": "U2FsdGVkX18XaIvHOUx9cu36xIEdu88hTdP8SwXjm88="
        }, {
          "num_cand": "U2FsdGVkX18sEOS1bLQ4ffc0VS8+wjjoT11sizLMbr0=",
          "cpf": "U2FsdGVkX18wfH83lwWhmj/Nda688/cVB85MxvfBsbI="
        }, {
          "num_cand": "U2FsdGVkX1/Ww627jfjSOzyTMmXxrqIkSmQHFC6uAQE=",
          "cpf": "U2FsdGVkX19eUBkCwkm5FSARE3PuPfMq5+xTT3LNmwM="
        }, {
          "num_cand": "U2FsdGVkX1+XXviq7a9iZRH4c72NXC/QPDtsHrcn5lE=",
          "cpf": "U2FsdGVkX1+B34KcuSGKY+FOEfbu0me8Goz59lUItbo="
        }, {
          "num_cand": "U2FsdGVkX18kV/W5WLXJxLlud3O5f2XyRlf9W9oKKgM=",
          "cpf": "U2FsdGVkX18CpJMObMbhH4nSQrR4jIWxsUFSa+Zr+OQ="
        }, {
          "num_cand": "U2FsdGVkX1+tOdc3KV7jl1V1tuOFR/YKCNLS/gyWNcw=",
          "cpf": "U2FsdGVkX182mdSty1sigT1ewkGvj6eWQQcjNhjUGqA="
        }, {
          "num_cand": "U2FsdGVkX189dvhThXzmwma338rSZNG8w1BzSDPuJ7I=",
          "cpf": "U2FsdGVkX1+iBHJLiKoFUi40kUEPpFdjjYBiucNdVXw="
        }, {
          "num_cand": "U2FsdGVkX1/M4yuplM4DVfkI9Y7seTEzeqROut7/3+I=",
          "cpf": "U2FsdGVkX1+JGU8KdxtCHqD8JxzzZMaiyXo4FUWMF38="
        }, {
          "num_cand": "U2FsdGVkX18qjNoBEG9sNvlN53lDhdvrC/ig24A/YFo=",
          "cpf": "U2FsdGVkX19DKH9NNaJ5P+iw7ybM9xZCvWbhJGLJ1po="
        }, {
          "num_cand": "U2FsdGVkX1+jDmc0qmVuRy7DvWYra1q1EQLJbNEM5ME=",
          "cpf": "U2FsdGVkX18jmhQKgSBSrwruBr3+8DqWCWbyd/BS6AU="
        }, {
          "num_cand": "U2FsdGVkX1+d7iCxUuF7+v81GTYy5pM37+RUbMrRsXw=",
          "cpf": "U2FsdGVkX19i7JHKFfLJPFVRnHmOA/3yKypmbUvPaoo="
        }, {
          "num_cand": "U2FsdGVkX1+oP5OlB8p4QxRhtR+K9MgdEuhMbKuIn8I=",
          "cpf": "U2FsdGVkX18/45UgwDf+w5kUGX7atA8v8sAeYgHXx7I="
        }, {
          "num_cand": "U2FsdGVkX19XL4OXJnmSSeLQLbBCyNKDRbPqLtBmsLM=",
          "cpf": "U2FsdGVkX1/xXIR1VXgzAWKmLTgPdunHNuZx0SCRs7A="
        }, {
          "num_cand": "U2FsdGVkX18TMkKZ1VBgkSuQs7qH4l5rTimQf47FNo0=",
          "cpf": "U2FsdGVkX1/typR3emz10+6nK88rwa+W/wkjXTA5w9I="
        }, {
          "num_cand": "U2FsdGVkX18JgKAfidgJET0NfgwF6oMw0zIyYBOcm0w=",
          "cpf": "U2FsdGVkX19to8jmD4SLWCernnMMa72hIevQATYxD4Q="
        }, {
          "num_cand": "U2FsdGVkX1+32xDomVbjbsBzzEm52I36YKhp0PjgC9o=",
          "cpf": "U2FsdGVkX1+z7uNR72mlBBvlapqU5XD6/WkRgtDs3XE="
        }, {
          "num_cand": "U2FsdGVkX18pgMdQ75NNqG5XtI2RjOYkN5YCMr5VIKs=",
          "cpf": "U2FsdGVkX1/+F0Z+1jfu4HhggHgIAJq8CFWfBF1lTP4="
        }, {
          "num_cand": "U2FsdGVkX195upVgAZZEk9FlP6Gta90RCZlycyvALMg=",
          "cpf": "U2FsdGVkX1/alVy98Dh1YQA8C/LaUEiJia0aKNHiTug="
        }, {
          "num_cand": "U2FsdGVkX1/8nczwBG+S1gzw6Yn1Le7cqLzP1449ulc=",
          "cpf": "U2FsdGVkX19htjkC1Zwj/ygB72ta4lGO+QiVjHlTeXY="
        }, {
          "num_cand": "U2FsdGVkX19D0ZVDHbgYnUXD0uw9CpiTTMEPQBgQPVE=",
          "cpf": "U2FsdGVkX1+PkvfBBeBYweHnNhAaWAohVcR5mtsWGdc="
        }, {
          "num_cand": "U2FsdGVkX19Pom9mWj2KKfqc2HF7p2Be8f8uT65xoLo=",
          "cpf": "U2FsdGVkX18qbLd0cfjjdZE4bcBhOfonXaiM41yoA/g="
        }, {
          "num_cand": "U2FsdGVkX1+S0WNzZxYHpCpFg0dCSSHR1nPMi7FvJDU=",
          "cpf": "U2FsdGVkX18WuLTTgkpl3O+VgPehpeiIr4iVcXe1Xv4="
        }, {
          "num_cand": "U2FsdGVkX189q75ZxA9dbocxhNpl1BvtkAO4MnWkOzs=",
          "cpf": "U2FsdGVkX18tRn8LPR7h5e+3jNrjjY+zqs/vkqTojGs="
        }, {
          "num_cand": "U2FsdGVkX19eOgVIQ3+fVawkwMGnFZRyetwZVtyKZZY=",
          "cpf": "U2FsdGVkX1+gAE+DnpBx+Olr/duApy95ZJPKBejnunI="
        }, {
          "num_cand": "U2FsdGVkX1+oL4xTREg2qbO0D/WVduuk0fdgufXdo9Y=",
          "cpf": "U2FsdGVkX18pl5t3v+RAsGItOPuaQnpF5jThWv97qEA="
        }, {
          "num_cand": "U2FsdGVkX1+4VD8NZeh1XN+7Suf9731ZjJTpVX260LU=",
          "cpf": "U2FsdGVkX1/gjgqdsK2x2fL5eS48VD2zOKsQSdcyq3Q="
        }, {
          "num_cand": "U2FsdGVkX1/AwMGw6egD891xaU1DTSXehFjo2JUy6H8=",
          "cpf": "U2FsdGVkX1+0k50xRYIFpb2AiHlQM40K6fwxoFtjUjU="
        }, {
          "num_cand": "U2FsdGVkX19ewhVF7VclKHDSaZit3qzMh2bE4m0lRKk=",
          "cpf": "U2FsdGVkX19vVIWqiqAyOrvUSs05RZLrYtu4N+Lz9No="
        }, {
          "num_cand": "U2FsdGVkX1/qS/JKRtRLDBOw/hsgIWbQSYoLBPoxpwQ=",
          "cpf": "U2FsdGVkX190g3XxKGSadER3BBrkLPm7WI/NmFAsLpc="
        }, {
          "num_cand": "U2FsdGVkX1986i3TxPnk/xKmMYsctleJf51Wgd+4uCY=",
          "cpf": "U2FsdGVkX19cnRbSU4WgookV/TcWaWkh6JhYTyUn3/o="
        }, {
          "num_cand": "U2FsdGVkX1+1pnVorAJXYf3bNrKf0tmxTvZbewvkJ7w=",
          "cpf": "U2FsdGVkX19cnZnk+nwDHG0ghD2l3ghUF2g6D4VF5Cw="
        }, {
          "num_cand": "U2FsdGVkX1+Fr97KbO4GEKuBsr8VUocTb3DCFOPaaz0=",
          "cpf": "U2FsdGVkX1+OunmTm8738bKs9rNbJqak6evjTopyOBo="
        }, {
          "num_cand": "U2FsdGVkX1+AHoVDIJiqztzo1PHWcjHXM/9zO0hENAE=",
          "cpf": "U2FsdGVkX19IPercF4kiFYmqMJTBxIwAlZXnWo8zMPg="
        }, {
          "num_cand": "U2FsdGVkX1+GS0Y5Zy+wuZVhHsc4goHrYMpkQ4KEWoE=",
          "cpf": "U2FsdGVkX19Ex+Y+y1Esw8KJ+haXEJNTpNHvkV6w58o="
        }, {
          "num_cand": "U2FsdGVkX1+L4qfux9itAjtUrLCD0Hl7K6wP0YmpWs0=",
          "cpf": "U2FsdGVkX1/Nj+zN27DNNCXqPXvbeVrwBJsqTmKOc6w="
        }, {
          "num_cand": "U2FsdGVkX1+bzb23PMRA/+qsQdzNHJvu71fBz5k1c9A=",
          "cpf": "U2FsdGVkX19UFhGLm6oxtCcAC1OTEPNQvP4HtsNm4ko="
        }, {
          "num_cand": "U2FsdGVkX19l6C2uPOIaZKqe6Cua6fPSoYJLENeiZU0=",
          "cpf": "U2FsdGVkX19I7rAhhFo0nS0KDjJklCgRJgRhWo/Juy0="
        }, {
          "num_cand": "U2FsdGVkX1+koPwc0eUGnqgVLit4M8boodBQ5ba8Z9c=",
          "cpf": "U2FsdGVkX19D7VSuqFaegdqHvC9RhLA4lA1bm7E5PxY="
        }, {
          "num_cand": "U2FsdGVkX1/5Qjg0N2QR4xlyoHoVdw7IgzvDh/Kkres=",
          "cpf": "U2FsdGVkX1/CQBRpwBP6syfH+E9il1BhWPPxJfEbcwk="
        }, {
          "num_cand": "U2FsdGVkX19e8P6BjX312eYunyieRG14owEQA+M0zG0=",
          "cpf": "U2FsdGVkX18qlPYiIuLv6O+HQkWid2xvj9qt/eleB8I="
        }, {
          "num_cand": "U2FsdGVkX19S9JRFc5asw/qEdeQ1K37g6PQxbiqHmSs=",
          "cpf": "U2FsdGVkX1+iTbt2/OtLxkp3UqHKVVoO1/tUrx1s2BQ="
        }, {
          "num_cand": "U2FsdGVkX18GdFVWGxzV9ry1m5b3on4I3FZ36BYuH5M=",
          "cpf": "U2FsdGVkX1+PO/W1pZpF2KdwjvcPiRJNhmXeLuuDYzM="
        }, {
          "num_cand": "U2FsdGVkX1/+1wovh+sb6HYRvrJex6HpBFQbYxbzE5Q=",
          "cpf": "U2FsdGVkX18LIjCWJO267yPwWwoXE1Ndv7SXp3DgOjs="
        }, {
          "num_cand": "U2FsdGVkX191YdW4ER6kiJTuZwdkTtsQGmhkvVvC+ow=",
          "cpf": "U2FsdGVkX1/ErR/J1lBNaiaWJJ9V+sP0hBsQ1WTu4Ns="
        }, {
          "num_cand": "U2FsdGVkX1+bjMNpgMEyKW7cLkvXONX24G1EDTXh6Ns=",
          "cpf": "U2FsdGVkX1+2vumO6VIpa/h9umXugLNgRX9UcsaHr+Y="
        }, {
          "num_cand": "U2FsdGVkX1+L4S8foW3imoH/SLGCfwvSoenercogv9k=",
          "cpf": "U2FsdGVkX1/BZG8aMI0SWn8RBsqd+IzLCtF/M7MGOFk="
        }, {
          "num_cand": "U2FsdGVkX18yV+Ub71AaQwImFjXiCaDm1omZFARfKKo=",
          "cpf": "U2FsdGVkX1+nJLi+sIhyaW+rwkA8byjrSYTTmpe2Ofw="
        }, {
          "num_cand": "U2FsdGVkX19HK7uiFX9N9REAUoai5ydP7MdFqibkYV4=",
          "cpf": "U2FsdGVkX1+OkbrUByzbP3YNsxRO2maPelHA8yYyvoI="
        }, {
          "num_cand": "U2FsdGVkX186M/pNee2Znycg/1jdQkq189Gba20cqX4=",
          "cpf": "U2FsdGVkX1/s3dB9itNoYQ8uoVdD2xM8xkxwrKS3WzU="
        }, {
          "num_cand": "U2FsdGVkX1+c/5wOHi5tmBxFkRMnkNPP8IRsyAMZH8g=",
          "cpf": "U2FsdGVkX18lWjK7L9xf4M1Sr6LUX/fV+2ESukL1CiQ="
        }, {
          "num_cand": "U2FsdGVkX19NRKq5NU9I21qYrE83B4TFhFQ9pO38mNY=",
          "cpf": "U2FsdGVkX1+529cWffht0fkqYrB0WDpZq3tbxqIs/pk="
        }, {
          "num_cand": "U2FsdGVkX1+PWFvSfnlRwsyy6LZLqLgeW3qm4Qmc/nY=",
          "cpf": "U2FsdGVkX1/OtRTfjpbY0dghljxL1dOfwl0lnf08B3o="
        }, {
          "num_cand": "U2FsdGVkX1+xMJeTAffG9zhhONXRgMpbamLkwLRkn2s=",
          "cpf": "U2FsdGVkX19DFmF82g2hWnFn2RJzPi4lJqFtn1wm8aY="
        }, {
          "num_cand": "U2FsdGVkX19gm7zPYz9utLgcr79/XF4fdD65YuWhK2Q=",
          "cpf": "U2FsdGVkX1/jBgy8Npt8vqahcsF0nKepd/aVpjU+Qqg="
        }, {
          "num_cand": "U2FsdGVkX1/HLL4uLaz7ehdqa0eJtiO1PDW2vjVNOeI=",
          "cpf": "U2FsdGVkX19AB34Mt7BX8vtGaa23NN2gHfp1UsT9j2Y="
        }, {
          "num_cand": "U2FsdGVkX19lFO9ftMTaXce+gkt+cOmxpIsg37FSAOs=",
          "cpf": "U2FsdGVkX1/l3bqfLFZ9iJ9GDgnmNZ9+Fc6kGE/b38Y="
        }, {
          "num_cand": "U2FsdGVkX19XQ0xZaJHMCRjQ5bnFrHZF/en8h6ZcYFE=",
          "cpf": "U2FsdGVkX1+6OmiJw59rZgBplp6440ElSie4Gv9IlC4="
        }, {
          "num_cand": "U2FsdGVkX1+Jcw1+Yllv4FiPVTa3RD9z1mbq5+MO3lo=",
          "cpf": "U2FsdGVkX1/p8S6rq1weDvyW2lsZ7boUDxuTp1I69tA="
        }, {
          "num_cand": "U2FsdGVkX19wJ1kflphbKINH2sTGZQi/cLiF33uz5mg=",
          "cpf": "U2FsdGVkX197HL8MDzeIWtJDBsgoiTaeYq75MOcyljQ="
        }, {
          "num_cand": "U2FsdGVkX1+ah5rtgqreyVEUZlU662oUoGXYSaLNIcg=",
          "cpf": "U2FsdGVkX1+vDYjsFc+x83MgbwbmEoIm4Iocc1JAsD8="
        }, {
          "num_cand": "U2FsdGVkX182r0tBLsPTUr8mNp5Sh7YSZAKuwRoTXlU=",
          "cpf": "U2FsdGVkX18QFBZpSULalIfd9R6In3x9lRYE49dAsKg="
        }, {
          "num_cand": "U2FsdGVkX1/PdcC3/SP88Nqy2+aq+Q5BP1Coy6frsC8=",
          "cpf": "U2FsdGVkX1+MJpRJELsXZ5O4uOSUpcolMP6w5OWEr7k="
        }, {
          "num_cand": "U2FsdGVkX1+A/ArnVH7+uRq2Y2wTuLY5xdAgjE8ocqA=",
          "cpf": "U2FsdGVkX18gZw1gWupVOxdt61n4YSoOYXnApNPv1MI="
        }, {
          "num_cand": "U2FsdGVkX19JnXKyBCTnl9+mycU9fXOByX7bI4PxzuM=",
          "cpf": "U2FsdGVkX199h7hQpG9T0GTKRSKmI0fpNSRmyq6L2Rk="
        }, {
          "num_cand": "U2FsdGVkX1/CzXdbfkU15O6sgdbdIGEXR3AsBBKLMkw=",
          "cpf": "U2FsdGVkX18P5+2jatvGcodNiYBNPHL52dHwN7cPyqk="
        }, {
          "num_cand": "U2FsdGVkX18JxPcywV2KXk1dEGwxmyo1lXJCUQF7bNI=",
          "cpf": "U2FsdGVkX19RFfryNpd5HlnoydB1L5lsEJXwxGpU/tQ="
        }, {
          "num_cand": "U2FsdGVkX18vOnNxvsinJMXHxv3AjQdYoO78Kn2HPtk=",
          "cpf": "U2FsdGVkX1943pXf8K2JrwLviWqWhUP2EhdGbfqmqAk="
        }, {
          "num_cand": "U2FsdGVkX18tP1R5zTv8Q1elqfBI8eaeok9YSGiiE7o=",
          "cpf": "U2FsdGVkX1+kGd7p8xaFSJGMxRwLdBLu20gREqi7ST8="
        }, {
          "num_cand": "U2FsdGVkX19nu1iCzx1z2+kmSntTEYEzCjdx2MWsT50=",
          "cpf": "U2FsdGVkX1/kumlgmHJyw65PemCXp3aTl5BTtj2MD0Q="
        }, {
          "num_cand": "U2FsdGVkX18o2vsdLuBW3nuu9hAVVbiEHvplt1EDe2E=",
          "cpf": "U2FsdGVkX19lN3SN9o9+Rw55FZUW46USt6T79KBRIE0="
        }, {
          "num_cand": "U2FsdGVkX1+lNLZ/fMtKj0A3tTxpQbgiF/Miuj+c/QU=",
          "cpf": "U2FsdGVkX18zyCea5VrquxKY6n9+rMvAf8YOwLh2GCQ="
        }, {
          "num_cand": "U2FsdGVkX1+4wJMN7xx60WsxUJLxGvCoct3QnfxZUxk=",
          "cpf": "U2FsdGVkX1/OBYv51GObws/mbLnsu3OIueoI64g9BTY="
        }, {
          "num_cand": "U2FsdGVkX1/+TSb2EvALH614+TcN4syvT+BDA9dNs3c=",
          "cpf": "U2FsdGVkX1+2Nu+ArFgaSqPl9P2138QYr8+gRVZaq7k="
        }, {
          "num_cand": "U2FsdGVkX18gYC+ik2SduRSOhAPdcAUtLUMLqdsm5nI=",
          "cpf": "U2FsdGVkX19rO6oPjDF9bGb1pWHeXLArF5+7dpmaIXc="
        }, {
          "num_cand": "U2FsdGVkX18nKJIDehg0LXfsQX6oomCfshe+rMgBMvE=",
          "cpf": "U2FsdGVkX1+2s3R4/trYpNY+TAD4FrNz4aiLKwN0L6E="
        }, {
          "num_cand": "U2FsdGVkX18VCzDRR3s54RwJcJEcoAly844HAAZvrII=",
          "cpf": "U2FsdGVkX18qUkOk8xsfK9cU9Xf5//lbpV8bWzJ8Jac="
        }, {
          "num_cand": "U2FsdGVkX1+hUs+MTy9awrdUHQMWdTsyWahRj7DAEnk=",
          "cpf": "U2FsdGVkX1+i2D2/qNfSCK++ZzkqxhC1tWzMKcAPok8="
        }, {
          "num_cand": "U2FsdGVkX19Tt0WVpFBBIbluLt9ovc139bJZ/J5WOJg=",
          "cpf": "U2FsdGVkX19hsiRaNAtXn6aHMVqI20OMw2VGm7Fvbp0="
        }, {
          "num_cand": "U2FsdGVkX1/jLa7CU6wvm68DR/KWsyLB+KDcp9hpNoQ=",
          "cpf": "U2FsdGVkX19l4WvwaMpKmqrMK0iJK51MwSRQxAOswQU="
        }, {
          "num_cand": "U2FsdGVkX1/I1PzjJjZpMot5qxrp14c14MgGDAvo/EU=",
          "cpf": "U2FsdGVkX180RPiKwe4fzQOVd3PLZj7DhCeuoYKsvU4="
        }, {
          "num_cand": "U2FsdGVkX1+HkiskREOhOtM78bzb/xKKLx5q1mMWF0E=",
          "cpf": "U2FsdGVkX18lLYCpDbDJxlVu9kPkvVsL8D/6i5/U0IE="
        }, {
          "num_cand": "U2FsdGVkX1/ObxryuaNGCFuq+uD94PBGyOcaEYRkHTI=",
          "cpf": "U2FsdGVkX19jjOjit4vEezlRmjefUhRdo+hiLSOKEwI="
        }, {
          "num_cand": "U2FsdGVkX1+MAja9gZarCCoVSMBLSoN0nGwCx0QSYaY=",
          "cpf": "U2FsdGVkX1/JOUtPZqGSmnf5XWd+uU2z81R4CSo5HFQ="
        }, {
          "num_cand": "U2FsdGVkX1/ezxFJBZBEe2mrq0RpZQ0jope5JNT3090=",
          "cpf": "U2FsdGVkX19dVAuwA9C5UbtBCbEZZyDP+Fv+/gGIq08="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2211/rec_isenc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
